import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2
} from '@angular/core';

@Directive({
  selector: 'img[csImgLoader]',
  standalone: false
})
export class ImgLoaderDirective {
  @Input('csImgLoader')
  public set url(val: string) {
    this.src = val;
  }

  @Input()
  public fallback: string;

  constructor(
    private elementRef: ElementRef<HTMLImageElement>,
    private renderer: Renderer2
  ) {}

  @HostListener('error')
  public error(): void {
    this.src = this.fallback;
  }

  private set src(val: string) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'src', val);
  }
}
